// @flow

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";
import auth from "../../../services/auth";
//import { history } from "../../../redux/store/configureStore";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import "../../../style/login.css";

import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";
import { createBrowserHistory } from 'history';


const cookies = new Cookies();
const history = createBrowserHistory();

class Login extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      login_token: "",
      logout_response: "",
      submitted: false,
      login_response: "",
      msgType: null,
      msg: null,
      hover: false,
      multi_lang: 'no',
      lang: '',
      //default_lang: 'en',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),

    };
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };

  isAuthenticated() {
    const token = auth.getToken();
    return token && token.length > 10;
  }

  renderAlert() {
    if (this.state.msgType && this.state.msg) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <a href="#" className="close" data-dismiss="alert" aria-label="close">
            &times;
          </a>
          <strong>{this.state.msgType.toUpperCase()} :</strong> {this.state.msg}
        </div>
      );
    }
  }

  render() {
    const { email, password, submitted } = this.state;
    const { isLogging } = this.props;
    const isAlreadyAuthenticated = this.isAuthenticated();

    return (
      <div>
        <div className="container min-height">
          <div className="panel margin-top margin-bottom">
              <Row className="margin-top margin-bottom">
                <Col md={12} xs={12}>
                <Col md={12} xs={12}>
                  {this.renderAlert()}
                </Col>
                <Col md={6} xs={12}>
                  <Row>
                    <Col md={12} xs={12}>
                      <h1>{languageConfig[this.state.default_lang].registered_customer}</h1>
                    </Col>
                    <Col md={12} xs={12}>
                      <p>
                        {languageConfig[this.state.default_lang].login_page_head}
                      </p>
                    </Col>
                    <Col md={12} xs={12}>
                      {isAlreadyAuthenticated ? (
                        localStorage.getItem("userTypeName") == "customer" ? (
                          <Redirect to={{ pathname: "./" }} />
                        ) : (
                          <Redirect to={{ pathname: "./dashboard" }} />
                        )
                      ) : (
                        <form className="form-horizontal" noValidate>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="cpassword">
                              <FormControl
                                type="text"
                                value={email}
                                placeholder={languageConfig[this.state.default_lang].email_address}
                                name="email"
                                autoComplete="off"
                                onChange={this.handlesOnEmailChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="inputPassword">
                              <FormControl
                                type="password"
                                value={password}
                                placeholder={languageConfig[this.state.default_lang].password}
                                name="email"
                                autoComplete="off"
                                onChange={this.handlesOnPasswordChange}
                              />
                            </FormGroup>
                          </Col>
                          <Row>
                            <Col md={6} xs={12}>
                              <Button
                                className="login-button"
                                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Login') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                                data-id = {'Login'}
                                onMouseEnter={this.hoverOn} 
                                onMouseLeave={this.hoverOff}
                                bsStyle="success"
                                disabled={isLogging}
                                type="submit"
                                onClick={this.handlesOnLogin.bind(this)}
                              >
                                {isLogging ? (
                                  <span>
                                    login in... &nbsp;
                                    <i className="fa fa-spinner fa-pulse fa-fw" />
                                  </span>
                                ) : (
                                  <span>{languageConfig[this.state.default_lang].login}</span>
                                )}
                              </Button>
                            </Col>
                            <Col md={6} xs={12}>
                              <Link replace to={"/forgot"} className="pull-right">
                               {languageConfig[this.state.default_lang].lost_password}
                              </Link>
                            </Col>
                          </Row>
                        </form>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={6} xs={12}>
                  <Row>
                    <Col md={12} xs={12}>
                      <h1>{languageConfig[this.state.default_lang].new_customer}</h1>
                    </Col>
                    <Col md={12} xs={12}>
                      <p>
                       {languageConfig[this.state.default_lang].login_page_body}
                      </p>
                    </Col>
                    <Col md={12} xs={12} className="margin-top">
                      <Button
                        bsStyle="success"
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Register') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                        data-id = {'Register'}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff}
                        type="submit"
                        onClick={() => this.context.router.history.push(`/register`)}
                      >
                        {languageConfig[this.state.default_lang].register}
                      </Button>
                    </Col>
                  </Row>
                </Col>
                </Col>
              </Row>
          </div>
        </div>
      </div>
    );
  }
  // #endregion

  handlesOnEmailChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ email: event.target.value.trim() });
    }
  };

  handlesOnPasswordChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      // should add some validator before setState in real use cases
      this.setState({ password: event.target.value.trim() });
    }
  };

  componentWillMount(){
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }

    componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if(nextProps.language){
      this.setState({default_lang: nextProps.language});
    }
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    
    if (nextProps.loginResponse.error)
      this.setState({ msgType: "error", msg: nextProps.loginResponse.error });
  }

  // #region on login button click callback
  handlesOnLogin = async (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }

    this.setState({ submitted: true });
    const { email, password } = this.state;
    const { dispatch } = this.props;

    try {
      if (email && password) {
        this.props.login(email, password);
        this.setState({ msgType: null, msg: null });
      } else {
        this.setState({
          msgType: "error",
          msg: "Email and Password fields are required"
        });
      }
    } catch (error) {
      /* eslint-disable no-console */
      this.setState({ msgType: "error", msg: error });
      /* eslint-enable no-console */
    }
  };
  // #endregion

  // #region on go back home button click callback
  goHome = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }

    const { history } = this.props;

    this.context.router.history.push({ pathname: "/" });
  };
  // #endregion
}

export default Login;



// WEBPACK FOOTER //
// ./src/app/views/admin/login/Login.js